import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=56919bbc&"
import script from "./NetworkError.vue?vue&type=script&lang=ts&"
export * from "./NetworkError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports